import React, { useEffect } from 'react';
import { Menu, Users, Settings, Home, Flag, Briefcase, Map, MapPin, UserCogIcon, UserPlus,VoteIcon, HospitalIcon, LayoutDashboard, Calendar, Book, BookOpenCheck, GraduationCap } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';
import { FaIntercom } from 'react-icons/fa';
import { useSelector } from 'react-redux';

const Sidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const {admin_type} = useSelector((state)=>state.auth)
  // Check if screen is mobile and set collapsed state
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) { // 768px is the standard md breakpoint
        setCollapsed(true);
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [setCollapsed]);

  const baseMenuItems = [
    { icon: <LayoutDashboard size={20} />, label: 'Dashboard', path: '/dashboard' },
    { icon: <Users size={20} />, label: 'Users', path: '/dashboard/users' },
    { icon: <Flag size={20} />, label: 'Reported Posts', path: '/dashboard/reported-posts' },
    { icon: <Briefcase size={20} />, label: 'Jobs', path: '/dashboard/jobs' },
    { icon: <Calendar size={20} />, label: 'Events', path: '/dashboard/events' },
    { icon: <MapPin size={20} />, label: 'User Geolocaton', path: '/dashboard/user-geolocation' },
    { icon: <UserCogIcon size={20} />, label: 'Applicants', path: '/dashboard/applicants' },
    { icon: <VoteIcon size={20} />, label: 'Attributes', path: '/dashboard/attributes' },
    { icon: <HospitalIcon size={20} />, label: 'Health Facilities', path: '/dashboard/health-facilities' },
    { icon: <BookOpenCheck size={20} />, label: 'Training Programs', path: '/dashboard/training-programs' },
    { icon: <GraduationCap size={20} />, label: 'Alumni', path: '/dashboard/alumni' },
  ];
  
  // Add Admin Management option only for super-admin
  const menuItems = admin_type === 'super_admin' 
    ? [...baseMenuItems, { icon: <UserPlus size={20} />, label: 'Admin Management', path: '/dashboard/admin' }]
    : baseMenuItems;

  return (
    <div className={`bg-white shadow-lg ${collapsed ? 'w-16' : 'w-64'} transition-all duration-300 h-full overflow-auto`}>
      <div className="p-4 flex items-center justify-between">
        {!collapsed && <span className="text-xl font-semibold">Admin</span>}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-gray-100 hidden md:block"
        >
          <Menu size={20} />
        </button>
      </div>
      <nav className="p-2 my-4">
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`flex items-center gap-4 p-2 rounded-lg hover:bg-gray-100 text-gray-700 mb-4 transition-colors
              ${currentPath === item.path ? 'bg-blue-50 text-blue-600' : ''}`}
          >
            <span className={currentPath === item.path ? 'text-blue-600' : ''}>
              {item.icon}
            </span>
            {!collapsed && (
              <span className={currentPath === item.path ? 'font-medium' : ''}>
                {item.label}
              </span>
            )}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;